<template>
  <div class="title-cell">
    <div class="title-cell-item">
      <div
        :class="{ double: index % 2 == 0, single: index % 2 != 0, label: true }"
      >
        <div v-for="(j, index) in item.label" :key="index">
          {{ j }}
        </div>
      </div>
      <div
        :class="{
          'cell-double': index % 2 == 0,
          'cell-single': index % 2 != 0,
        }"
      >
        <content-cell v-for="(i, key) in item.value" :key="key" :content="i" />
      </div>
    </div>
  </div>
</template>
<script>
import ContentCell from './content-cell'
export default {
  name: 'title-cell',
  props: ['item', 'index'],
  components: {
    ContentCell,
  },
}
</script>
<style lang="scss" scoped>
.title-cell {
  .title-cell-item {
    display: flex;
    .label {
      color: #29bdb9;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .double {
      background-color: #e4f7f7;
    }
    .single {
      background-color: #daf4f4;
    }
    .cell-double {
      background-color: #f4fdfd;
    }
    .cell-single {
      background-color: #e6fafa;
    }
  }
}
@media screen  and (max-width:600px){
  .title-cell {
    .title-cell-item {
      .cell-double {
        background-color: #f4fdfd;
        width:200px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tariff/title-type/title-cell.vue